// extracted by mini-css-extract-plugin
export default {"root":"ListItem_root__X9D4n","title":"ListItem_title__nihLi","desp":"ListItem_desp__ub2os","remark":"ListItem_remark__rRDOg"};